import { PlanDetail } from '../types';
import { INITIAL_PLANS } from '../services/mockData';
import { api } from '../services/api';

export interface ConnectedCheckoutParams {
  sessionId?: string;
  customerId?: string;
  planId?: string;
  tier?: string;
  email?: string;
  name?: string;
  phone?: string;
  country?: string;
  gstin?: string;
  coupon?: string;
  billingCycle?: 'monthly' | 'quarterly' | 'annually';
  successUrl?: string;
  cancelUrl?: string;
  redirectUrl?: string;
  isEmbedded?: boolean;
}

export function parseCheckoutParams(): ConnectedCheckoutParams {
  let search = window.location.search;
  if (!search && window.location.hash.includes('?')) {
    search = window.location.hash.substring(window.location.hash.indexOf('?'));
  }
  const params = new URLSearchParams(search);

  const billingCycleParam = params.get('billing_cycle') || params.get('billingCycle') || params.get('cycle') || params.get('interval');
  let billingCycle: 'monthly' | 'quarterly' | 'annually' = 'monthly';
  if (billingCycleParam === 'quarterly' || billingCycleParam === '3m') billingCycle = 'quarterly';
  else if (billingCycleParam === 'annually' || billingCycleParam === 'yearly' || billingCycleParam === '1y') billingCycle = 'annually';

  return {
    sessionId: params.get('checkout_session') || params.get('session_id') || params.get('session') || undefined,
    customerId: params.get('customer_id') || params.get('customerId') || undefined,
    planId: params.get('plan_id') || params.get('planId') || params.get('plan') || undefined,
    tier: params.get('tier') || params.get('plan_tier') || undefined,
    email: params.get('email') || params.get('customer_email') || undefined,
    name: params.get('name') || params.get('customer_name') || undefined,
    phone: params.get('phone') || params.get('customer_phone') || undefined,
    country: params.get('country') || params.get('customer_country') || undefined,
    gstin: params.get('gstin') || params.get('tax_id') || undefined,
    coupon: params.get('coupon') || params.get('promo') || params.get('discount') || undefined,
    billingCycle,
    successUrl: params.get('success_url') || params.get('redirect_url') || params.get('return_url') || undefined,
    cancelUrl: params.get('cancel_url') || params.get('fallback_url') || undefined,
    redirectUrl: params.get('redirect_url') || undefined,
    isEmbedded: params.get('embedded') === 'true' || window.self !== window.top,
  };
}

export async function resolvePlanFromParams(params: ConnectedCheckoutParams): Promise<PlanDetail> {
  const target = (params.planId || params.tier || '').toLowerCase().trim();
  
  // Try remote plans first
  try {
    const plans = await api.plans.getAll();
    if (plans && plans.length > 0) {
      if (!target) return plans[0] || INITIAL_PLANS[1];
      const match = plans.find(
        (p: any) =>
          p.id?.toLowerCase() === target ||
          p.tier?.toLowerCase() === target ||
          p.name?.toLowerCase() === target
      );
      if (match) return match;
    }
  } catch (err) {
    console.warn('Failed to fetch dynamic plans, falling back to presets', err);
  }

  // Fallback to presets
  if (!target) return INITIAL_PLANS[1];
  const presetMatch = INITIAL_PLANS.find(
    (p: any) =>
      p.id?.toLowerCase() === target ||
      p.tier?.toLowerCase() === target ||
      p.name?.toLowerCase() === target
  );
  return presetMatch || INITIAL_PLANS[1];
}

export function notifyConnectedWebsite(event: 'SUBSCALE_READY' | 'SUBSCALE_CHECKOUT_SUCCESS' | 'SUBSCALE_CHECKOUT_CANCEL', payload?: any) {
  const message = { type: event, subscale: true, payload, timestamp: Date.now() };
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, '*');
  }
  if (window.opener) {
    window.opener.postMessage(message, '*');
  }
}
